import { emptyLoadableResource } from '@bd/helpers'
import { NotificationsState } from '@bd/store-modules/types/main'

export const state: NotificationsState = {
  notifications: emptyLoadableResource(),
  notificationsVisible: false,
  unreadNotificationsCount: 0
}
